export default __webpack_public_path__ + "bb1115d4d751a82db37ef69d10e1f14b.png";